import { yupResolver } from "@hookform/resolvers/yup"
import { useEffect } from "react"
import * as yup from "yup"

import {
  Accordion,
  Button,
  Group,
  Select,
  Switch,
  TextInput,
} from "@mantine/core"
import { IconDeviceFloppy } from "@tabler/icons-react"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { OwnerSetting, SMSLanguage, SMSProvider } from "../../../models/owner-setting.model"
import {
  useLazyGetOwnerSettingsQuery,
  useUpdateOwnerSettingMutation,
} from "../store/owner.query"

type Props = {
  id: string
}
const SettingComponent = ({ id }: Props) => {
  console.log("🚀 ~ SettingComponent ~ id:", id)
  const { t } = useTranslation()

  const [getOwnerSettings, ownerSettings] = useLazyGetOwnerSettingsQuery()
  const [updateSettings, updateSettingsResponse] =
    useUpdateOwnerSettingMutation()

 

  let schema: any = yup.object().shape({
    // smsProvider: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),
    // providerToken: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),

    // timeUnit: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),

    // frequencyAmount: yup.number().required(t("nameRequired")),
    // daysRemainingToStart: yup.number().required(t("nameRequired")),

    // sendTime: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),

    // smsLanguage: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),

    // timezone: yup
    //   .string()
    //   .min(2, t("nameMin", { count: 2 }))
    //   .max(100, t("nameMax", { count: 100 }))
    //   .required(t("nameRequired")),

    // defaultSettings: yup.boolean().required(t("nameRequired")),
    // parkingPricePerHour: yup.number().required(t("nameRequired")),
  })

  const defaultValues: OwnerSetting = {
    ownerId: id,
    smsProvider: SMSProvider.Afro,
    providerToken: "",
    timeUnit: "hour",
    frequencyAmount: 1,
    daysRemainingToStart: 0,
    sendTime: "08:00",
    smsLanguage: SMSLanguage.English,
    timezone: "Africa/Addis_Ababa",
    defaultSettings: true,
    parkingPricePerHour: 0,
  }

  const {
    register,
    setValue,
    getValues,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<OwnerSetting>({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "all",
  })

  const defaultWatch = watch("defaultSettings")
  function onSubmit(data: any) {
    data.id = ownerSettings?.data?.id;
    data.ownerId = id;
    data.defaultSettings = defaultWatch;
    updateSettings(data)
  }

   useEffect(() => {
    getOwnerSettings(id).then((response: any) => {
      reset(response.data)
    })
  }, [id])

  function onError(error: any) {
    console.log("🚀 ~ onError ~ error:", error)
  }
  return (
    <div className="flex  justify-center h-full">
      <form
        onSubmit={handleSubmit(onSubmit, onError)}
        className="w-full gap-y-4 dark:text-white"
      >
        <Accordion
          defaultValue={["info"]}
          multiple
          variant="separated"
          classNames={{
            control:
              "bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg shadow-lg rounded-xl border border-gray-700",
          }}
        >
          <Accordion.Item value="info">
            <Accordion.Control>Owner Setting</Accordion.Control>
            <Accordion.Panel className="bg-gray-800">
              <div className="flex-col space-y-4 bg-gray-800">
                <div className="flex flex-col md:flex-row md:w-[49%] w-full space-x-0  md:space-x-4  justify-between">
                  <Controller
                    control={control}
                    name="defaultSettings"
                    render={({ field }) => (
                      //@ts-ignore
                      <Switch
                        className={"my-1"}
                        checked={field.value}
                        // {...field}
                        onChange={(event: any) =>
                          field.onChange(event.currentTarget.checked)
                        }
                        label="Use Default Settings"
                      />
                    )}
                  />
                </div>

                {!defaultWatch && (
                  <>
                    <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                      <Controller
                        control={control}
                        name="smsProvider"
                        render={({ field }) => (
                          <Select
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            // onKeyDown={debounce(
                            //   (event: any) =>
                            //     setTenantSearch(event?.target?.value),
                            //   1000,
                            // )}
                            searchable
                            clearable
                            withAsterisk
                            error={
                              errors.smsProvider &&
                              `${errors?.smsProvider?.message}`
                            }
                            label={"Sms Provider"}
                            placeholder={"Sms Provider"}
                            data={[
                              {
                                label: SMSProvider.Afro,
                                value: SMSProvider.Afro,
                              },
                              {
                                label: SMSProvider.Geez,
                                value: SMSProvider.Geez,
                              },
                              {
                                label: SMSProvider.Hahu,
                                value: SMSProvider.Hahu,
                              },
                            ]}
                            {...field}
                          />
                        )}
                      />
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        error={
                          errors.providerToken &&
                          `${errors?.providerToken?.message}`
                        }
                        // withAsterisk
                        label={"Provider Token"}
                        placeholder="Provider Token"
                        {...register("providerToken")}
                      />
                    </div>

                    <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                      <Controller
                        control={control}
                        name="smsLanguage"
                        render={({ field }) => (
                          <Select
                            classNames={{ label: "dark:text-white" }}
                            className="w-full"
                            // onKeyDown={debounce(
                            //   (event: any) =>
                            //     setTenantSearch(event?.target?.value),
                            //   1000,
                            // )}
                            searchable
                            clearable
                            withAsterisk
                            error={
                              errors.smsLanguage &&
                              `${errors?.smsLanguage?.message}`
                            }
                            label={"Sms Provider"}
                            placeholder={"Sms Provider"}
                            data={[
                              {
                                label: SMSLanguage.English,
                                value: SMSLanguage.English,
                              },
                              {
                                label: SMSLanguage.Amharic,
                                value: SMSLanguage.Amharic,
                              }
                            ]}
                            {...field}
                          />
                        )}
                      />
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        type="number"
                        error={
                          errors.frequencyAmount &&
                          `${errors?.frequencyAmount?.message}`
                        }
                        withAsterisk
                        label={"Frequency Amount"}
                        placeholder={"Frequency Amount"}
                        {...register("frequencyAmount")}
                      />
                    </div>
                    {/* <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        error={
                          errors.timeUnit && `${errors?.timeUnit?.message}`
                        }
                        withAsterisk
                        label={"Time Unit"}
                        placeholder={"Time Unit"}
                        {...register("timeUnit")}
                      />
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        error={
                          errors.timezone && `${errors?.timezone?.message}`
                        }
                        // withAsterisk
                        label={"Time Zone"}
                        placeholder="Time Zone"
                        {...register("timezone")}
                      />
                    </div> */}
                    <div className="flex flex-col md:flex-row w-full space-x-0  md:space-x-4  justify-between">
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        type="number"
                        error={
                          errors.daysRemainingToStart &&
                          `${errors?.daysRemainingToStart?.message}`
                        }
                        // withAsterisk
                        label={"Days Remaining To Start"}
                        placeholder="Days Remaining To Start"
                        {...register("daysRemainingToStart")}
                      />
                      <TextInput
                        classNames={{ label: "dark:text-white" }}
                        className="w-full"
                        type="number"
                        error={
                          errors.parkingPricePerHour &&
                          `${errors?.parkingPricePerHour?.message}`
                        }
                        // withAsterisk
                        label={"Parking Price Per Hour"}
                        placeholder="Parking Price Per Hour"
                        {...register("parkingPricePerHour")}
                      />
                    </div>
                  </>
                )}
              </div>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>

        <div className="w-full flex justify-end items-center">
          <Group position="right" mt="xl">
            <>
              <Button
                classNames={{ label: "flex space-x-1 " }}
                variant="default"
                className="dark:text-white hover:bg-primary hover:dark:bg_dark_primary hover:text-white"
                type="reset"
                size="xs"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-current h-6"
                    viewBox="0 0 32 32"
                  >
                    <path d="M18.90625 4.09375C18.101563 4.09375 17.265625 4.367188 16.625 4.9375L16.625 4.96875L16.59375 5L4.90625 16.59375C3.695313 17.804688 3.703125 19.777344 4.84375 21.0625L4.875 21.09375L4.90625 21.09375L10.90625 27.09375C11.511719 27.699219 12.320313 27.992188 13.125 28L28 28L28 26L16.5 26L27 15.5C28.265625 14.234375 28.304688 12.210938 27.09375 11L21.09375 5C20.488281 4.394531 19.710938 4.09375 18.90625 4.09375 Z M 18.875 6.125C19.195313 6.125 19.492188 6.210938 19.6875 6.40625L25.6875 12.40625C26.074219 12.792969 26.128906 13.558594 25.59375 14.09375L20.5625 19.125L12.90625 11.46875L17.96875 6.4375L18 6.40625C18.253906 6.195313 18.570313 6.125 18.875 6.125 Z M 11.46875 12.90625L19.125 20.5625L14.03125 25.65625C14.019531 25.664063 14.011719 25.679688 14 25.6875C13.484375 26.117188 12.691406 26.066406 12.3125 25.6875L6.34375 19.75C6.328125 19.730469 6.328125 19.707031 6.3125 19.6875C5.902344 19.171875 5.9375 18.375 6.3125 18Z" />
                  </svg>
                </span>
                <span>{t("reset")}</span>
              </Button>
              <Button
                variant="filled"
                className="bg-primary text-white"
                type="submit"
                classNames={{ label: "flex space-x-1" }}
                size={"xs"}
                loading={updateSettingsResponse.isLoading}
              >
                <span>
                  <IconDeviceFloppy size={22} strokeWidth={1.5} />
                </span>
                <span>{t("update")}</span>
              </Button>
            </>
          </Group>
        </div>
      </form>
    </div>
  )
}

export default SettingComponent
